import React from 'react';
import CustomizableDashboard from '../../../components/dashboard/CustomizableDashboard';
import { WIDGET_CATEGORIES } from '../../../components/dashboard/widgetRegistry';

/**
 * Hub Dashboard Page
 *
 * Executive dashboard showing unified platform health across all modules.
 * Aggregates data from GenAIOps, AgentOps, DataOps, and CloudOps.
 *
 * Features:
 * - System health score (aggregate)
 * - Cross-platform cost tracking
 * - Module status grid with health badges
 * - Cross-module alerts
 * - Drag & drop widget arrangement
 * - Backend persistence
 * - Admin "Set as Default" for organization
 */
const HubDashboardPage: React.FC = () => {

  return (
    <CustomizableDashboard
      title="Dashboard"
      description="Unified view of platform health, costs, and operations across all modules"
      storageKey="hub-dashboard-layout"
      context="hub"
      widgetCategory={WIDGET_CATEGORIES.HUB}
      useBackendPersistence={true}
      allowSetDefault={true}
    />
  );
};

export default HubDashboardPage;
